<template>
  <sliding-tabs :activeTab="activePerformanceTab" class="PERFORMANCE-TABS">
    <sliding-tabs-content
        v-for="(tab, index) in tabs"
        :key="tab.key"
        :name="tab.key"
        :titleProps="{
          title: tab.label,
          titleClass: (index ? 'text-capitalize p-x-2' : 'FIRST-TAB-TITLE p-x-2'),
          to: {
            name: 'dashboard::pro::performance',
            params: { activePerformanceTab: tab.key }
          },
        }"
    />
  </sliding-tabs>
</template>

<script>
import { PERFORMANCE_TAB_NAMES } from '@/constants/performance-tab-names';
import SlidingTabs from '@/components/SlidingTabs';
import SlidingTabsContent from '@/components/SlidingTabs/SlidingTabsContent';

export default {
  PERFORMANCE_TAB_NAMES,
  name: 'performance-tabs',
  components: {
    SlidingTabs,
    SlidingTabsContent,
  },
  data () {
    return {
      tabs: [
        this.$options.PERFORMANCE_TAB_NAMES.summary,
        this.$options.PERFORMANCE_TAB_NAMES.history,
        this.$options.PERFORMANCE_TAB_NAMES.reviews,
        this.$options.PERFORMANCE_TAB_NAMES.points,
      ],
    };
  },
  computed: {
    activePerformanceTab () {
      return this.$route.params.activePerformanceTab;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .PERFORMANCE-TABS {
    height: 42px;
    display: flex;
    flex: 0 0 auto;
    border-bottom: 1px solid $color-gray30;
  }

  /deep/ .FIRST-TAB-TITLE {
    text-transform: capitalize;
  }
</style>
